/* eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */

import RevampApiServices from '@/services/revampAPI';
import LocalStorage from '@/services/localstorage';
// import CryptoJS from 'crypto-js';

// actions
const actions = {
  login({ commit }, data) {
    return new Promise((resolve, reject) => {
      // const signature = CryptoJS.SHA256(`${data.api_key}PAXEL123${data.api_secret}`);
      RevampApiServices.post('/api/ecomm-tools/v1/login', data, '')
        .then((response) => {
          const responseData = response.data;
          if (responseData.code === 200 || responseData.status_code === 200) {
            const authData = JSON.stringify(responseData.data);
            LocalStorage.setAuth(authData);
            commit('setLogin', {
              isLogin: true,
              auth: authData,
            });
            resolve(responseData);
          }
        })
        .catch((error) => {
          LocalStorage.removeAuth();
          commit('setLogin', {
            isLogin: false,
            auth: {},
          });
          reject(error);
        });
    });
  },
  logout({ commit }) {
    LocalStorage.removeAuth();
    commit('setLogin', {
      isLogin: false,
      auth: {},
    });
  },
  shipmentDetail({ commit }, shipmentCode) {
    return new Promise((resolve, reject) => {
      const auth = JSON.parse(LocalStorage.getAuth());
      RevampApiServices.get(`/api/ecomm-tools/v1/shipment/details/${shipmentCode}`, auth.token)
        .then((response) => {
          const responseData = response.data;
          if (responseData.code === 200 || responseData.status_code === 200) {
            commit('setShipmentDetail', responseData.data);
            resolve(responseData);
          }
        })
        .catch((error) => {
          commit('setShipmentDetail', {});
          reject(error);
        });
    });
  },
  updateStatusShipment({ commit }, data) {
    return new Promise((resolve, reject) => {
      const auth = JSON.parse(LocalStorage.getAuth());
      const payload = { status: data.shipment_status };
      RevampApiServices.post(`/api/ecomm-tools/v1/shipment/update-shipment-status/${data.shipment_code}`, payload, auth.token)
        .then((response) => {
          const responseData = response.data;
          if (responseData.code === 200 || responseData.status_code === 200) {
            commit('setShipmentDetail', responseData.data);
            resolve(responseData);
          }
        })
        .catch((error) => {
          commit('setShipmentDetail', {});
          reject(error);
        });
    });
  },
  shipmentBatchDetail({ commit }, bookingCode) {
    return new Promise((resolve, reject) => {
      const auth = JSON.parse(LocalStorage.getAuth());
      RevampApiServices.get(`/api/ecomm-tools/v1/shipment/batch/details/${bookingCode}`, auth.token)
        .then((response) => {
          const responseData = response.data;
          if (responseData.code === 200 || responseData.status_code === 200) {
            commit('setShipmentBatchDetail', responseData.data);
            resolve(responseData);
          }
        })
        .catch((error) => {
          commit('setShipmentBatchDetail', {});
          reject(error);
        });
    });
  },
  updateStatusShipmentBatch({ commit }, data) {
    return new Promise((resolve, reject) => {
      const auth = JSON.parse(LocalStorage.getAuth());
      const payload = { status: data.shipment_status_batch };
      RevampApiServices.post(`/api/ecomm-tools/v1/shipment/batch/update-shipment-status/${data.booking_code}`, payload, auth.token)
        .then((response) => {
          const responseData = response.data;
          if (responseData.code === 200 || responseData.status_code === 200) {
            commit('setShipmentBatchDetail', responseData.data);
            resolve(responseData);
          }
        })
        .catch((error) => {
          commit('setShipmentBatchDetail', {});
          reject(error);
        });
    });
  },
};

export default actions;
